import { Component, createRef, h } from "preact";

import { classNames } from "../helpers";
import Icon from "./Icon.jsx";

export default class TextArea extends Component {
  textarea = createRef();

  handleChange = (event) => {
    if (this.props.onChange)
      return this.props.onChange(event.target.value, event);

    this.props.onInput && this.props.onInput(event);
    this.props.onUpdate && this.props.onUpdate(event.target.value);
  };

  componentDidMount() {
    M.updateTextFields();
    M.textareaAutoResize(this.textarea.current);
  }

  render(props) {
    const { value } = this.props;
    const id = props.id || props.name;

    return (
      <div
        class={classNames(
          "input-field text-field",
          props.class,
          props.iconBefore && "text-field--with-icon",
          props.error && "text-field--invalid invalid",
          props.label && "text-field--with-label"
        )}
      >
        {props.iconAfter && (
          <Icon class="text-field__suffixIcon">{props.iconAfter}</Icon>
        )}

        <textarea
          class="materialize-textarea"
          id={id}
          ref={this.textarea}
          {...props}
          value={value}
          onChange={this.handleChange}
        >
          {props.value}
        </textarea>
        {props.label && (
          <label for={id}>
            {props.label}
            {props.mandatory && "*"}
          </label>
        )}

        {props.inputPrefix && (
          <span class="text-field__inputPrefix">{props.inputPrefix}</span>
        )}
        {props.info && (
          <span class="text-field__helper-text">{props.info}</span>
        )}
        {props.error && (
          <span class="text-field__helper-text">{props.error}</span>
        )}

        {props.iconBefore && (
          <Icon class="text-field__prefixIcon">{props.iconBefore}</Icon>
        )}
      </div>
    );
  }
}
